function isiOS() {
    // 检测 userAgent
    const userAgent = window.navigator.userAgent;
    const isiOSFromUA = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    // 检测 platform
    const platform = window.navigator.platform;
    const isiOSFromPlatform = ['iPad', 'iPhone', 'iPod'].includes(platform);

    // 检测 macOS 上的 iPad
    const isMacWithTouch = platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;

    return isiOSFromUA || isiOSFromPlatform || isMacWithTouch;
}

function isWhiteBrowser() {
    const ua = navigator.userAgent.toLowerCase();
    // 浏览器白名单
    const whiteList = ['whale','crios']
    return whiteList.some(item => ua.includes(item))
}
export function isWhale(){
    return isWhiteBrowser() && isiOS()
}
export function isIosWhite() {
    // return isiOS() && isWhiteBrowser()
    return true
}